const Error = () => {
	return (
		<div className='mainContainer'>
			<div className='errorPage'>
				<h1>404</h1>
				<h4>We are sorry, But the page you are looking for does not exist</h4>
			</div>
		</div>
	)
}

export default Error
